<template>
  <v-layout align-center column>
    <p class="title-a">Siapa Kami</p>
    <v-skeleton-loader
      type="image"
      class="Dompetkilat-Image"
      v-if="!isImgLoaded"
    ></v-skeleton-loader>
    <img
      src="../../assets/career/image-1.png"
      @load="onImgLoad"
      class="Dompetkilat-Image"
    />
    <div class="Desc-Box">
      <p class="Desc">
        Kami adalah pakar keuangan, pakar IT, desainer, operator, HR, marketer
        yang bekerja bersama untuk
        <span class="text-style-1"
          >memperluas kebebasan finansial seluas-luasnya pada masyarakat.</span
        >
        Semua orang berhak sejahtera.
      </p>
      <p class="Desc">
        Berlokasi di Sudirman - Thamrin. Rumah sejuta start-up Indonesia.
        Bersiaplah menuju masa depan dengan teknologi.
      </p>
    </div>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>

<style scoped>
.title-a {
  width: 328px;
  flex-grow: 0;
  margin: 46px 0 10px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Desc {
  flex-grow: 0;
  font-family: Sora;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc-Box {
  width: 328px;
  flex-grow: 0;
  margin: 16px 0 0;
  font-family: Sora;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc .text-style-1 {
  font-weight: bold;
}
.Dompetkilat-Image {
  width: 327.8px;
  height: 204.1px;
  flex-grow: 0;
  margin: 32px 0.2px 16px 0;
  object-fit: contain;
}
</style>
